import { useBlocker } from 'react-router';

const useRouteBlocker = ({ callback }: { callback?: () => void } = {}) => {
  const routeBlocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (currentLocation.pathname !== nextLocation.pathname && routeBlocker.state === 'blocked') {
      callback && callback();
      return true; // Prevent navigation
    }
    return false; // Allow navigation
  });

  const onBlockRoute = () => {
    routeBlocker.state = 'blocked';
  };

  const onUnblockRoute = () => {
    routeBlocker.state = 'unblocked';
  };

  const onProceedingRoute = () => {
    routeBlocker.state = 'proceeding';
  };

  return {
    routeBlocker,
    onBlockRoute,
    onUnblockRoute,
    onProceedingRoute,
  };
};

export default useRouteBlocker;
